import { useTranslation } from 'react-i18next';
import { Card } from '@/common/components/Card/Card';
import { Heading } from '@/common/components/Heading/Heading';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { Stack } from '@/common/components/Stack/Stack';
import { TMemberSimulation } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { DateUtils } from '@/common/utils/date';

export const FamilyMembersTable = ({
  selectedPersons,
}: TFamilyMembersTableProps) => {
  const { t } = useTranslation();

  return (
    <Card plain>
      <Stack gap="lg">
        <Heading level={4}>
          {t(
            'dashboard.insurance_detail.add_family_members.confirm.family_members.card.title'
          )}
        </Heading>
        {selectedPersons.map((person) => (
          <Stack key={person.fullName} gap="sm">
            <LabeledValue
              orientation="horizontal"
              label={t('general.labels.name')}
              value={person.fullName}
            />
            <LabeledValue
              orientation="horizontal"
              label={t('general.labels.tax_number')}
              value={person.taxNumber?.value}
            />
            <LabeledValue
              orientation="horizontal"
              label={t('general.labels.kinship_degree')}
              value={t(`general.kinship.${person.type}`)}
            />
            <LabeledValue
              orientation="horizontal"
              label={t('general.labels.birth_date')}
              value={DateUtils.formatDate(person.birthdate)}
            />
            <LabeledValue
              orientation="horizontal"
              label={t('general.labels.gender')}
              value={t(`general.gender.${person.gender}`)}
            />
          </Stack>
        ))}
      </Stack>
    </Card>
  );
};

export type TFamilyMembersTableProps = {
  selectedPersons: TMemberSimulation[];
};
